<template>
  <div>
    <top></top>
    <div class="back-grey">
      <div class="swpier">
        <el-carousel height="500px" trigger="click">
          <el-carousel-item v-for="(item, index) in bannerList" :key="index">
            <img
              ref="image"
              :src="item.image"
              alt=""
              @click="imgBtn(item.url)"
            />
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- 全网底价 -->
      <div class="container box">
        <div class="title F-flex">
          <div class="flex ali-cen">
            <div class="title-big">今日特价 全网底价</div>
            <div class="title-line">|</div>
            <div class="title-small">Today's special price</div>
          </div>
        </div>
        <div class="flex">
          <div class="hot-item bor-none pad-none">
            <img
              :src="seckill.lists[0].image"
              @click="jump(seckill.lists[0].id)"
              alt=""
              style="width: 100%; height: 100%"
            />
          </div>
          <div
            class="hot-item"
            v-for="(item, index) in seckill.lists.slice(1,6)"
            @click="jump(item.id)"
            :key="index"
          >
            <img :src="item.image" alt="" />
            <div class="hot-con text-center">
              <div class="hot-title">
                {{ item.title }}
              </div>
              <div class="hot-money">¥{{ item.price }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 活动 -->
      <div class="container flex jus-between">
        <div class="new">
          <div class="title F-flex">
            <div class="flex ali-cen">
              <div class="title-big">新品发布</div>
              <div class="title-line">|</div>
              <div class="title-small">New product launch</div>
            </div>
            <div class="geng_inf" @click="more">
              更多 <i class="iconfont ficon-right"></i>
            </div>
          </div>
          <div class="new-goods flex">
            <div class="new-img index_cur">
              <img
                :src="new_product.lists[0].image"
                @click="jump(new_product.lists[0].id)"
                alt=""
                style="width: 176px; height: 341px"
              />
            </div>
            <div class="new-right index_cur">
              <div
                class="new-item"
                v-for="(item, index) in new_product.lists.slice(1, 5)"
                @click="jump(item.id)"
                :key="index"
              >
                <img :src="item.image" alt="" />
                <div class="new-item-con">
                  <div class="f14 ff14" style="line-height: 30px">
                    {{ item.title }}
                  </div>
                  <div class="F-flex">
                    <span class="text-decoration f10 grey"
                      >原价：¥{{ item.original_price }}</span
                    >
                    <span class="f14 orange">¥{{ item.price }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="special">
            <div class="title F-flex">
              <div class="flex ali-cen">
                <div class="title-big">新品专区</div>
                <div class="title-line">|</div>
                <div class="title-small">Daily Specials</div>
              </div>
              <div class="geng_inf" @click="more">
                更多 <i class="iconfont ficon-right"></i>
              </div>
            </div>
            <div class="special-left F-flex">
              <div
                class="special-item text-center index_cur"
                @click="jump(item.id)"
                v-for="(item, index) in new_product_area.lists.slice(0, 4)"
                :key="index"
              >
                <img :src="item.image" alt="" />
                <div class="f12" style="line-height: 30px">
                  {{ item.title }}
                </div>
                <div class="orange f14">¥{{ item.price }}</div>
              </div>
            </div>
          </div>
          <div class="special" style="background-color: #e2d1f3">
            <div class="title F-flex">
              <div class="flex ali-cen">
                <div class="title-big">特价专区</div>
                <div class="title-line">|</div>
                <div class="title-small">Daily Specials</div>
              </div>
              <div class="index_cur" @click="tejia">
                更多 <i class="iconfont ficon-right"></i>
              </div>
            </div>
            <div class="special-left F-flex">
              <div
                class="special-item text-center index_cur"
                v-for="(item, index) in special.lists.slice(0, 4)"
                @click="jump(item.id)"
                :key="index"
              >
                <template v-if="index % 2 === 0">
                  <img :src="item.image" alt="" />
                  <div class="f12" style="line-height: 30px">
                    {{ item.title }}
                  </div>
                </template>
                <template v-else>
                  <div class="f12" style="line-height: 30px">
                    {{ item.title }}
                  </div>
                  <img :src="item.image" alt="" />
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--每周积分  -->
      <div class="container jifen">
        <div class="title F-flex">
          <div class="flex ali-cen">
            <div class="title-big">每周积分</div>
            <div class="title-line">|</div>
            <div class="title-small">Weekly points</div>
          </div>
        </div>
        <div class="person-wrap">
          <swiper :options="swiperOption" ref="mySwiper">
            <!-- slides -->
            <swiper-slide v-for="(item, index) in scoreSkuList" :key="index">
              <div @click="jump(item.id)">
                <img :src="item.image" alt="" class="lunbotu" />
                <span class="iamge_title">{{ item.title }}</span>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <!-- 推荐品牌 -->
      <div class="container tuijian">
        <div class="tu_ji shdow1" v-for="(item,index) in brand" :key="index">
          <img :src="item.image" alt="" />
        </div>
      </div>

      <!-- 商品列表 -->
      <!--  v-if="index != category.length - 1" -->
      <div
        class="container goods-type"
        v-for="(item, index) in category"
        :key="index"

      >
        <div class="title F-flex">
          <div class="flex ali-cen">
            <div class="title-big">{{ item.title }}</div>
          </div>
          <div class="index_cur" @click="typrMore">
            更多 <i class="iconfont ficon-right"></i>
          </div>
        </div>
        <div class="flex ali-cen index_cur">
          <img
            :src="item.lists[0].image"
            alt=""
            class="img shdow1"
            @click="jump(item.lists[0].id)"
          />
          <div
            class="type-item text-center shdow1"
            v-for="(items, index) in item.lists.slice(1, 5)"
            :key="index"
            @click="jump(items.id)"
          >
            <img :src="items.image" alt="" />
            <div class="f14" style="line-height: 30px">
              {{ items.title }}
            </div>
            <div class="orange f16">¥{{ items.price }}</div>
          </div>
        </div>
      </div>

      <!-- 广告图 -->
      <div class="container index_cur">
        <el-carousel height="396px" direction="vertical" :autoplay="false">
          <el-carousel-item v-for="(item,index) in bannerList2" :key="index">
            <img :src="item.image" alt="" @click="imgBtn(item.url)" />
          </el-carousel-item>
        </el-carousel>
      </div>

      <!-- 商品 -->
      <div class="container">
        <div class="title title-tag ali-cen flex">
          <div class="title-big">工具/器械/手机</div>
        </div>
      </div>

      <div class="container">
        <div class="goods-box flex ali-cen flex-wrap">
          <div
            class="goods-item index_cur shdow1"
            v-for="(item, index) in category[category.length - 1].lists"
            :key="index"
            @click="jump(item.id)"
          >
            <img :src="item.image" alt="" class="goods-img" />
            <div class="goods-name flex ali-cen">
              <div class="goods-tag">修复</div>
              <div class="goods-name-text">{{ item.title }}</div>
            </div>
            <div class="goods-text">
              {{ item.subtitle }}
            </div>
            <div class="goods-price F-flex">
              <div style="color: #ff6701; font-size: 14px">
                ¥{{ item.price }}
              </div>
              <div class="goods-btn">立即购买</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import {
  category,
  lists,
  pchome,
  banners_pc,
  scoreSkuPrice,
  newProduct,
 
} from "@/api/index.js";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  data() {
    return {
      category: [], //商品
      seckill: {}, //全网底价商品
      new_product: {}, //新品发布商品
      new_product_area: {}, //新品专区商品
      special: {}, // 特价专区商品
      brand: {},
      bannerList: [],
      bannerList2: [],
      swiperOption: {
        slidesPerView: 8, //一行显示3个
        // loopedSlides: 3,
        spaceBetween: 30, //间隔30
        freeMode: true,
        speed: 1000, //滑动速度
        autoplay: {
          disableOnInteraction: false,
          delay: 3000,
        },
      },
      scoreSkuList: [],
     
    };
  },
  beforeCreate() {
    document.querySelector("body").setAttribute("style", "background:#f5f5f5");
  },
  created() {
    // this.$store.commit('edit','hello')

    console.log(this.$store.getters.name, "pppp");
    this.index();
    this.banner2();
    this.banner1();
    this.getSeckilList();
    // this.goodSearchs();
    // 接入美洽
    (function(a, b, c, d, e, j, s) {
        a[d] = a[d] || function() {
            (a[d].a = a[d].a || []).push(arguments)
        };
        j = b.createElement(c),
            s = b.getElementsByTagName(c)[0];
        j.async = true;
        j.charset = 'UTF-8';
        j.src = 'https://static.meiqia.com/widget/loader.js';
        s.parentNode.insertBefore(j, s);
    })(window, document, 'script', '_MEIQIA');
    _MEIQIA('entId', 'b3753895cb84a99b26e0227173623601');
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  mounted() {},
  methods: {
    index() {
      pchome().then((res) => {
        if (res.code == 1) {
          this.category = res.data.category;
          console.log('ressss',res);
          this.seckill = res.data.seckill;
          this.new_product = res.data.new_product;
          this.new_product_area = res.data.new_product_area;
          this.special = res.data.special;
          this.brand = res.data.brand.lists.slice(0, 6);
        }
      });
    },
    // getScoreSku() {
    //   scoreSkuPrice({}).then((res) => {
    //     if (res.code !== 1) {
    //       return;
    //     }
    //     this.scoreSkuList = res.data.data;
    //     console.log(this.scoreSkuList);
    //   });
    // },
    jump(e) {
      this.$router.push({ name: "info", query: { id: e } });
    },
    jumpScore(e) {
      this.$router.push({
        name: "scoreInfo",
        query: { id: e, type: "score" },
      });
    },
    banner1() {
      banners_pc({ status: "Home" }).then((res) => {
        this.bannerList = res.data.lists;
        console.log(this.bannerList);
        //this.imgLoad();
      });
    },
    banner2() {
      banners_pc({ status: "Home2" }).then((res) => {
        this.bannerList2 = res.data.lists;
      });
    }, 
 

    imgBtn(url) {
      console.log(url);
      //window.location.href = url
      if (url == "") {
        return;
      }
      window.open(url);
    },
    more() {
      this.$router.push({ path: "/new" });
    },
    //special
    tejia() {
      this.$router.push({ path: "/special" });
    },
    typrMore() {
      this.$router.push({ path: "/type" });
    },
    //积分福利
    getSeckilList(){
    newProduct({activity:'scores',type:'ing'}).then(res=>{
     if (res.code !== 1) {
          return;
        }
    this.scoreSkuList = res.data[0].goodsList.data;
    console.log('scoreSkuList',res)
    })
    }

  },
  components: {
    top,
    bottom,
    Swiper,
    SwiperSlide,
  },
};
</script>



<style lang="less" scoped>
.shdow1{
  transition: all .2s linear;
}
.shdow1:hover{
transform: translateX(0) translateY(-5px);
box-shadow: 0px 9px 31px 0px rgba(0, 0, 0, 0.1);
}
.lunbotu {
  width: 100%;
  height: 86px;
}
.img {
  width: 176px;
  height: 243px;
  margin-right: 30px;
}
.swpier {
  img {
    width: 100%;
    height: 100%;
  }
}
.iamge_title {
  font-size: 12px;
  color: #333333;
  overflow:hidden; //超出的文本隐藏
  text-overflow:ellipsis; //溢出用省略号显示
  white-space:nowrap; //溢出不换行
  width: 110px;
  display: inline-block;
  
}
.swiper-slide {
  text-align: center;
  cursor: pointer;
}
.container {
  margin-bottom: 27px;
  .el-carousel__container {
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.box {
  padding: 0 15px;
  background-color: #fff;
  margin-top: 35px;
  height: 341px;
}
.title {
  height: 70px;

  .geng_inf {
    cursor: pointer;
  }
  .title-big {
    color: #0097fe;
    font-size: 22px;
  }
  .title-line {
    margin: 0 10px;
  }
  .title-small {
    color: #666;
    font-size: 16px;
  }
}

.hot-item {
  cursor: pointer;
  width: 176px;
  height: 243px;
  background: #ffffff;
  border: 1px solid #d2d2d2;
  padding: 9px 5px;
  margin-right: 23px;
  transition: all .2s linear;

  &:last-child {
    margin-right: 0;
  }
  img {
    width: 166px;
    height: 131px;
    margin: 0 auto;
  }
  .hot-con {
    color: #333;
    padding: 20px 0;
    line-height: 20px;
    .hot-title {
      font-size: 14px;
        overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
    }
    .hot-subhead {
      font-size: 12px;
    }
    .hot-money {
      font-size: 14px;
      color: #ff6701;
    }
  }
}
.hot-item:hover{
  transform: translateX(0) translateY(-5px);
  box-shadow: 0px 9px 31px 0px rgba(0, 0, 0, 0.1);
  
}
.new {
  width: 612px;
  height: 439px;
  padding: 0 15px;
  background: #d0e7f6;
  .new-right {
    margin-left: 30px;
    display: flex;
    flex-wrap: wrap;
    .new-item {
      margin-right: 35px;
      margin-bottom: 15px;
      width: 144px;
      transition: all .2s linear;
      img {
        width: 144px;
        height: 114px;
      }
    }
    .new-item:hover {
       transform: translateX(0) translateY(-5px);
       box-shadow: 0px 9px 31px 0px rgba(0, 0, 0, 0.1);
     
    }
  }
}
.special {
  width: 560px;
  height: 214px;
  background: #f6dfd0;
  margin-bottom: 10px;
  padding: 0 15px;
  .special-left {
    .special-item {
      transition: all .2s linear;
      img {
        width: 124px;
        height: 86px;
      }
    }
    .special-item:hover{
      transform: translateX(0) translateY(-5px);
      box-shadow: 0px 9px 31px 0px rgba(0, 0, 0, 0.1);
    }
  }
}
.logo {
  height: 142px;
  background: #f7f7f7;
  border: 1px solid #0097fe;
  padding: 16px 12px;
  background-color: #fff;
}
.goods-type {
  height: 341px;
  background: #ffffff;
  padding: 0 15px;
  .type-item {
    margin-right: 40px;
        padding: 30px 0;
    &:last-child {
      margin-right: 0;
    }
    img {
      width: 206px;
      height: 164px;
    }
  }
}
.title-tag {
  height: 64px;
  background: #ffffff;
  padding: 0 15px;
}
.goods-box {
  height: 100%;
  .goods-item {
    width: 231px;
    height: 301px;
    background: #ffffff;
    border: 1px solid #d2d2d2;
    padding: 10px;
    margin-right: 9px;
    margin-bottom: 14px;
    &:nth-child(5n + n) {
      margin-right: 0;
    }
    .goods-img {
      width: 207px;
      height: 200px;
      margin-bottom: 10px;
    }
    .goods-name {
      font-size: 16px;
      .goods-tag {
        width: 43px;
        height: 15px;
        background: #5db031;
        border-radius: 10px;
        text-align: center;
        font-size: 10px;
        line-height: 15px;
        color: #fff;
      }
      .goods-name-text {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 166px;
      }
    }
    .goods-text {
      font-size: 12px;
      margin: 5px 0;
    }
    .goods-btn {
      width: 70px;
      height: 22px;
      background: #ff6701;
      text-align: center;
      line-height: 22px;
      color: #fff;
      font-size: 12px;
      border-radius: 11px;
    }
  }
}

.index_cur {
  cursor: pointer;
   transition: all .2s linear;
}
.new-img:hover{
 transform: translateX(0) translateY(-5px);
box-shadow: 0px 9px 31px 0px rgba(0, 0, 0, 0.1);
}
.new-item:hover {
 transform: translateX(0) translateY(-5px);
box-shadow: 0px 9px 31px 0px rgba(0, 0, 0, 0.1);
}
.jifen {
  width: 1200px;
  height: 214px;
  background: rgba(93, 176, 49, 0.15);
  padding-left: 15px;
  display: flex;
  flex-direction: column;
}
.tuijian {
  width: 1200px;
  height: 142px;
  background: #f7f7f7;
  border: 1px solid #0097fe;
  display: flex;
  align-items: center;
  .tu_ji {

    width: 190px;
    height: 110px;
    margin: 0 12px;
    img {
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
  }
}
.paoma {
  display: flex;
}
.paoma_ {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-right: 22px;
  // width: 100%;
  img {
    width: 124px;
    height: 86px;
    display: flex;
  }
}
.person-wrap {
  width: 1160px;
  height: 120px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue